import Grid from '@mui/material/Unstable_Grid2';
import { Alert, Box, FormControl, Typography } from '@mui/material';

import DeliveredOrdersHistoryWidget from './delivered-orders-history-widget/delivered-orders-history-widget';
import GovernorateDistributionWidget from './governorate-distribution-widget/governorate-distribution-widget';
import ProfitReport from './profit-report/profit-report';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { API_ENDPOINT } from '../../../configurations/global.config';
import axios from 'axios';
import DeliveryDashboard from './delivery-dashboard';
import { DeliveryState, PaymentState } from '../../../enums/orders';
import { DoubleDate } from '../double-date-picker/double-date-picker.interfaces';
import DoubleDatePicker from '../double-date-picker/double-date-picker';
import {
  CompactMerchantType,
  MerchantType,
} from '../../../interfaces/delivery-company/merchants';
import AutocompleteWithThrottle from '../autocomplete-with-throttle/autocomplete-with-throttle';
import { format } from 'date-fns';
import { Lightbulb } from '@mui/icons-material';
import { user_is_admin, user_is_org_or_employee } from '../../../utils/permissions';
import CriticalOrders from '../critical-orders-alert/critical-orders-alert';
import { UserType } from '../../../enums/users';
export interface OrderStats {
  delivery: Record<DeliveryState, any>;
  payment: Record<PaymentState, number>;
  order_results_per_month: {
    delivered_standard: number[];
    delivered_return: number[];
    cancelled: number[];
  };
  orders_per_governorate: { governorate: string; total: number }[];
}

export interface WidgetProps {
  stats?: OrderStats;
  isLoading: boolean;
  errorMessage: string;
}

function Home() {

  const [stats, setStats] = useState<OrderStats>();
  const { user, config } = useContext(AuthContext);

  const [message, setMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [dateFilter, setDateFilter] = useState<DoubleDate>();
  const [merchant, setMerchant] = useState<MerchantType | null>(null);

  useEffect(() => {
    const fetchAndSetStats = async () => {
      setIsLoading(true);
      try {
        let endpoint = `${API_ENDPOINT}/api/v1/stats/`;

        const queryParams: string[] = [];
        if (dateFilter?.startDate)
          queryParams.push(
            `date_from=${encodeURIComponent(dateFilter.startDate.format('YYYY-MM-DD'))}`
          );

        if (dateFilter?.endDate)
          queryParams.push(
            `date_to=${encodeURIComponent(dateFilter.endDate.format('YYYY-MM-DD'))}`
          );

        if (merchant != null) {
          queryParams.push(`merchant=${merchant.id}`);
        }

        endpoint += `?${queryParams.join('&')}`;
        const response = await axios.get<OrderStats>(endpoint, config);
        setStats(response.data);
      } catch (e) {
        console.log(e);
        setMessage('Failed to collect data');
      }
      setIsLoading(false);
    };
    fetchAndSetStats();
  }, [dateFilter, merchant]);

  const handleFetchMerchants = async (
    query: string
  ): Promise<MerchantType[]> => {
    const endpoint = `${API_ENDPOINT}/api/v1/merchants/?page_size=10&name_or_phone=${encodeURIComponent(query)}`;

    try {
      const response = await axios.get<{
        count: number;
        results: MerchantType[];
      }>(endpoint, config);
      return response.data.results;
    } catch (error) {
      console.log(error);
    }
    return [];
  };

  let explainDateScope = '';
  if (dateFilter) {
    if (dateFilter?.startDate != null && dateFilter.endDate != null) {
      explainDateScope = `between ${format(dateFilter.startDate.toDate(), 'dd-MM-yyyy')} and ${format(dateFilter.endDate.toDate(), 'dd-MM-yyyy')}`;
    } else if (dateFilter?.startDate != null && dateFilter.endDate == null) {
      explainDateScope = `since ${format(dateFilter.startDate.toDate(), 'dd-MM-yyyy')}`;
    } else if (dateFilter?.startDate == null && dateFilter.endDate != null) {
      explainDateScope = `on ${format(dateFilter.endDate.toDate(), 'dd-MM-yyyy')} or before`;
    }
  }

  let explainMerchantScope = '';

  if (user?.type == UserType.ORGANISATION || user?.type == UserType.EMPLOYEE)
    explainMerchantScope =
      merchant == null ? 'for all merchants' : `for merchant ${merchant.name}`;
  else explainMerchantScope = `for ${user?.name}`;

  return (
    <div className="content-container">
      <Box>
        <Typography
          variant="h3"
          component="h3"
          sx={{ textAlign: 'center', mt: 3, mb: 3 }}
        >
          Main Dashboard
        </Typography>


      <Box display={"flex"} justifyContent={"center"} width={"100%"} mb={2}>
           <CriticalOrders />
      </Box>
       

        <FormControl sx={{ p: 0 }}>
          {user_is_org_or_employee(user) && (
            <>
              <AutocompleteWithThrottle
                label={'Search merchant by name or phone number'}
                required={false}
                fetch={handleFetchMerchants}
                value={merchant}
                fetchAllOnLoad
                getOptionLabel={(option: CompactMerchantType) =>
                  option.name + ' ' + option.phone_number
                }
                onChange={(e, value) => {
                  setMerchant(value);
                }}
              />
              <br />
            </>
          )}
          <DoubleDatePicker
            dateFilterAction={(d: DoubleDate) => setDateFilter(d)}
            headless
          />
        </FormControl>

        <br />
        <br />
        <Alert severity="info" icon={<Lightbulb fontSize="inherit" />}>
          Data below are for orders created {explainDateScope}{' '}
          {explainMerchantScope}
        </Alert>

        <DeliveryDashboard
          stats={stats}
          isLoading={isLoading}
          errorMessage={message}
        />
      </Box>
    </div>
  );
}

export default Home;
